import { render, staticRenderFns } from "./ExpertItemReplace.vue?vue&type=template&id=76841c0a&scoped=true"
import script from "./ExpertItemReplace.vue?vue&type=script&lang=js"
export * from "./ExpertItemReplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76841c0a",
  null
  
)

export default component.exports